import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import AssignmentsForPatients from "../AssignmentsForPatients";
import {
  AssignmentDispatchContext,
  AssignmentStateContext,
  useAssignmentStoreDefaults,
} from "../AssignmentsForPatients/assignmentStore";
import {
  getAssignments,
  getSubmissions,
} from "../AssignmentsForPatients/useSubmissionsApi";
import { fetchAssignmentsAction } from "store/actions/assignments";
import { useCurrentUser } from "utils/hooks";

const AssignmentContextWrapper = () => {
  const { assignmentState, setAssignmentState } = useAssignmentStoreDefaults();
  const ref = useRef(false);
  const dispatch = useDispatch();
  const { user } = useCurrentUser();

  useEffect(() => {
    if (ref.current) return;
    const fetchData = async () => {
      if (assignmentState.initialized) return;
      const submissions = await getSubmissions(
        user?.activeOrganizationId || "NA"
      );
      const assignments = await getAssignments();
      setAssignmentState({
        assignments,
        submissions,
      });
      dispatch(fetchAssignmentsAction([...assignments]));
    };
    fetchData();
    ref.current = true;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AssignmentStateContext.Provider value={assignmentState}>
      <AssignmentDispatchContext.Provider value={setAssignmentState}>
        <AssignmentsForPatients />
      </AssignmentDispatchContext.Provider>
    </AssignmentStateContext.Provider>
  );
};

export default AssignmentContextWrapper;
